/**
 * /devhub/evidence — Evidence packs (operator). Surface Layer (/01). REQ-001.91 Phase 3.
 * Live operator panel (DevHubEvidencePackPanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubEvidencePackPanel } from '../features/control-plane/DevHubEvidencePackPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/evidence')({ component: EvidencePage });

function EvidencePage() {
  return (
    <DevHubPanelPage
      title="Evidence packs"
      subtitle="Audit evidence bundles per requirement and gate."
      status={{ label: 'live', live: true }}
    >
      <DevHubEvidencePackPanel />
    </DevHubPanelPage>
  );
}
